import { useToast } from '@cad-arc';
import { useEffect, useState } from 'react';
import { useEnabledFeatures } from '../common/hooks/enabled-features/use-enabled-features';
import { useBootstrapState } from '../bootstrap/bootstrap-provider';

export function useDexUserIdentificationErrorToast() {
    const { showDexUserIdentificationError } = useBootstrapState();
    const { dataExchange } = useEnabledFeatures();
    const [
        haveShownDexUserIdentificationError,
        setHaveShownDexUserIdentificationError,
    ] = useState<boolean>(false);
    const toast = useToast();
    useEffect(() => {
        if (
            dataExchange &&
            showDexUserIdentificationError &&
            !haveShownDexUserIdentificationError
        ) {
            toast({
                description: (
                    <>
                        <strong>Data Exchange Error: User Identification.</strong>
                        <br />
                        The Mark43 Desktop Integration Service is not installed or not running. Make
                        sure DIS is functioning properly and contact an administrator if this error
                        persists.
                    </>
                ),
                status: 'default',
                position: 'top',
                duration: 100 * 1000,
            });
            setHaveShownDexUserIdentificationError(true);
        }
    }, [showDexUserIdentificationError, haveShownDexUserIdentificationError, toast, dataExchange]);
}
